import { Link } from "render/ui/trigger/Link";
import styles from "./styles.module.sass";

interface RetryScanButtonProps {
  onPress(): void;
  isDisabled?: boolean;
}

export function RetryScanButton({ onPress, isDisabled }: RetryScanButtonProps) {
  return (
    <Link onPress={onPress} isDisabled={isDisabled} className={styles.retry}>
      Scan new label
    </Link>
  );
}
